import React from 'react';
import { isEmpty } from 'lodash';
import Select from 'react-select';

import FileCopyIcon from '@material-ui/icons/FileCopyRounded';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import MenuItem from '@material-ui/core/MenuItem';

import { getSuitableDays, getDefaultDietariesValues } from '../../common/routes';
import ACButton from '../../atoms/ACButton';
import ACStatus from '../../atoms/ACStatus';

import styles from './RouteDetails.module.scss';
import ACMedia from '../../atoms/ACMedia';
import ThemeDesigner from 'components/common/ThemeDesigner';
import SectionHeading from '../../common/SectionHeading'

import ProductPicker from 'components/atoms/ProductAutoComplete';
import { getProductByIdImperative } from 'components/common/actions/products';

// A route is connected to a legacy product. Assigning an Occasions package component here has
// been retired: a component now names the routes that may deliver it, authored on the
// component's own page in the Hub and mirrored onto the route as `componentIds`. That is
// many-to-many and coexists with the product connection, where this control was one route to
// one component and cleared the product. Routes still carrying the old `componentId` keep
// working - it is read by eee, the HQ mismatch alert and the planner's route card - so nothing
// was migrated; it just cannot be set from here any more.

export default class RouteDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        productPrice : '',
        productCity : '',
        productCountry : '',
    };

    this.onChangeText = this.onChangeText.bind(this);
    this.onChangeIntroduction = this.onChangeIntroduction.bind(this);
    this.onChangeVariables = this.onChangeVariables.bind(this);
    this.onChangeProductId = this.onChangeProductId.bind(this);
    this.onUploadIntroduction = this.onUploadIntroduction.bind(this);
    this.onClickClearMedia = this.onClickClearMedia.bind(this);
  }

  onClickStatusChange() {
    const routeDetails = this.state.routeDetails;
    const routeStatus = routeDetails.routeStatus;
    routeDetails.routeStatus = !routeStatus;

    this.setState({
      routeDetails: routeDetails,
    });
  }

  onChangeText(key, event) {
    let value = event.target.value;
    this.props.onUpdateRouteFunc(key, value);
  }

  onChangeIntroduction(key, event) {
    let value = event.target.value;
    this.props.onUpdateRouteIntroductionFunc(key, value);
  }


  onChangeVariables(key, event) {
    let value = event.target.checked;
    let { variables } = this.props;
    if (!variables) {
      variables = {};
    }

    variables[key] = value;
    this.props.onUpdateRouteFunc('variables', variables);
  }

  async onChangeProductId(productId) {
    const product = await getProductByIdImperative(productId);


    let price = '';
    if (this.props.route.price) {
      if (this.props.route.price.currency) price += this.props.route.price.currency;
      if (this.props.route.price.price) price += ` ${this.props.route.price.price}`;
    }

    let productPrice = this.state.productPrice ? this.state.productPrice : price;
    let productCity = '';
    let productCountry = '';


    if (product) {
      if (!isEmpty(product.productCities) && product.productCities.length > 0) {
        productCountry = product.productCities[0].country;
        productCity = product.productCities[0].name;
      }
      if (!isEmpty(product.prices) && product.prices[0].price)
        productPrice = product.prices[0].price;
    }

    this.setState({ productPrice, productCity, productCountry})


    this.props.onUpdateRouteFunc('product', product);
  }

  onUploadIntroduction(files) {
    this.props.onUploadIntroductionFunc(this.props.route.id, files);
  }

  onClickClearMedia() {
    const { route } = this.props;
    const introduction = route.introduction || {};
    if (introduction?.medias && introduction?.medias.length > 0) delete introduction['medias'];
    this.props.onUpdateRouteIntroductionFunc('medias', []);
    this.setState({
      route,
    });
  }

  // get suitable dietaries for the UI
  getSuitableDietaries(dietaries) {
    if (isEmpty(dietaries)) {
      dietaries = [];
    }
    let suitableDietaries = getDefaultDietariesValues();

    // let isValid = true;
    suitableDietaries.forEach((defaultDiet) => {
      if (dietaries[defaultDiet.name] && dietaries[defaultDiet.name] === true) {
        defaultDiet.value = true;
      }
    });
    return suitableDietaries;
  }

  onInputChangeMoreToExplore = (query) => {
    if (!query) return;
    this.props.onInputChangeMoreToExploreFunc(query);
  };

  onChangeMoreToExplore = (mte) => {
    let value = mte.value;
    this.props.onUpdateRouteFunc('moreToExploreId', value);
  };

  renderTop(route) {
    const name = route.name || '';
    const status = route.status || '';
    const stops = this.props.stops;

    return (
      <div className={styles.top}>
        <div className={styles.header}>
          Details
          <ACButton
            key="HeaderAddButton"
            text={'Clone'}
            icon={<FileCopyIcon key="HeaderAddButtonFileCopyIcon" />}
            onClickFunc={() => this.props.onCopyRouteFunc(route, stops)}
          />
        </div>
        <div>
          <span className={styles.routeName}>
            <div className={styles.name}>
              <TextField
                value={name}
                className={styles.nameText}
                onChange={(e) => this.onChangeText('name', e)}
                placeholder="Route Name"
              />
            </div>
          </span>
          <ACStatus
            status={status}
            text={status}
            isEditable={true}
            type="route"
            onChangeFunc={(e) => this.onChangeText('status', e)}
            key="routeStatusKey"
          />
        </div>
      </div>
    );
  }



  renderDetails(route, users) {
    const owner = route.userId || '';

    return (
      <div>
        <TextField
          select
          id="simple-start-adornment"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                Owner
              </InputAdornment>
            ),
          }}
          className={styles.textField}
          value={owner}
          onChange={(e) => this.onChangeText('userId', e)}
          SelectProps={{
            anchororigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformorigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            getcontentanchorel: null,
          }}
        >
          {this.renderUsers(users)}
        </TextField>
        {this.renderProductConnection(route)}
        {this.renderComponents(route)}
      </div>
    );
  }

  /**
   * The Occasions package components this route may deliver, read-only.
   *
   * Authored on the component's own page in the Hub, which writes both content-api's record and
   * this mirror; there is nothing to edit here, and an editable copy would give the pairing two
   * writers. Names come from the snapshot aex stores beside each id, so no content-api lookup
   * is needed - a name that looks out of date is refreshed by re-linking the route in the Hub.
   *
   * A route can carry a product and components at the same time, so this sits alongside the
   * product connection above rather than replacing it. Absent when there are no links, so a
   * plain product route looks exactly as it did.
   */
  renderComponents(route) {
    const components = (route?.components || []).filter(Boolean);
    if (isEmpty(components)) return null;

    return (
      <TextField
        id="simple-start-adornment"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" className={styles.adornment}>
              Components
            </InputAdornment>
          ),
        }}
        value={components.map((c) => c.title || c.id).join(', ')}
        className={styles.textField}
        helperText="Delivered for these package components. Edit in the Hub, on the component."
        disabled
        multiline
      />
    );
  }

  renderProductConnection(route) {
    const product = route?.product;
    const country = this.state.productCountry || product?.productCities?.[0]?.country || '';
    const city = this.state.productCity || product?.productCities?.[0]?.name || '';
    const price = this.state.productPrice || product?.prices?.[0]?.price || '';

    return (
      <div>
        <ProductPicker onChangeProductId={this.onChangeProductId} selectedProduct={product} />
        <TextField
          id="simple-start-adornment"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                Product Id
              </InputAdornment>
            ),
          }}
          value={route?.productId || product?.id || ''}
          className={styles.textField}
          disabled
        />
        <TextField
          id="simple-start-adornment"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                Country
              </InputAdornment>
            ),
          }}
          value={country}
          className={styles.textField}
          disabled
        />
        <TextField
          id="simple-start-adornment"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                ProductCity
              </InputAdornment>
            ),
          }}
          value={city}
          className={styles.textField}
          disabled
        />
        <TextField
          id="simple-start-adornment"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                Price
              </InputAdornment>
            ),
          }}
          value={price}
          className={styles.textField}
          disabled
        />
      </div>
    );
  }

  renderWhens(providerWhens) {
    let daysUI = getSuitableDays(providerWhens) || [];
    return daysUI.map((d) => {
      let backgroundColor = '';
      let color = '';

      if (d.value === true) {
        backgroundColor = '#52A8EF';
        color = 'white';
      } else {
        backgroundColor = 'white';
        color = 'black';
      }
      return (
        <ACButton
          text={d.alias}
          backgroundColor={backgroundColor}
          color={color}
          fontSize="10px"
          padding="1px 5px"
          className={styles.capitalized}
          key={d.alias}
        />
      );
    });
  }

  renderMoreToExploreCollection() {
    let { moreToExploreCollection = [], route = {} } = this.props;
    let { moreToExplore = {} } = route;
    let selectedMoreToExplore = {};

    if (route && route.moreToExploreId) {
      const findMoreToExplore = moreToExploreCollection.filter((mte) => {
        console.log('selectedMoreToExplore', mte);
        return mte.id === route.moreToExploreId;
      });
      if (!isEmpty(findMoreToExplore)) {
        selectedMoreToExplore.label = findMoreToExplore[0].name;
        selectedMoreToExplore.value = findMoreToExplore[0].id;
      } else if (!isEmpty(moreToExplore)) {
        selectedMoreToExplore.label = moreToExplore.name;
        selectedMoreToExplore.value = moreToExplore.id;
      }
    }
    let mMoreToExploreCollection = [{ label: '--- None/Clear ---', value: null }];
    if (!moreToExploreCollection) return <div />;
    moreToExploreCollection.forEach((mte) => {
      let mMoreToExplore = {
        label: mte.name,
        value: mte.id,
      };
      mMoreToExploreCollection.push(mMoreToExplore);
    });

    return (
      <div className={styles.productAutoComplete}>
        <div className={styles.productAutoCompleteMain}>
          <span>More to Explore</span>
          <Select
            className={styles.productSelect}
            inputId="react-select-single"
        TextFieldProps={{
              label: 'More To Explore',
              InputLabelProps: {
                htmlFor: 'react-select-single',
                shrink: true,
              },
              placeholder: 'Select More To Explore',
            }}
            options={mMoreToExploreCollection}
            // components={components}
            value={selectedMoreToExplore}
            onChange={this.onChangeMoreToExplore}
            onInputChange={this.onInputChangeMoreToExplore}
          />
        </div>
      </div>
    );
  }

  renderDietaries(itemDietaries) {
    let dietaries = this.getSuitableDietaries(itemDietaries);
    if (isEmpty(dietaries)) return <div />;

    return dietaries.map((d) => {
      let name = d.alias;
      let value = d.value;

      return (
        <FormControlLabel
          control={<Checkbox color="primary" checked={value} disabled />}
          label={name}
          key={name}
          className={styles.capitalized}
        />
      );
    });
  }

  renderVariables(variables) {
    let isWineFriendly = false;
    if (!isEmpty(variables)) {
      isWineFriendly = variables.isWineFriendly;
    }

    let vs = [
      {
        name: 'isWineFriendly',
        text: 'Wine Friendly',
        value: isWineFriendly,
      },
    ];

    return vs.map((v) => {
      let name = v.name;
      let text = v.text;
      let value = v.value;

      return (
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={value}
              onChange={(e) => this.onChangeVariables(name, e)}
            />
          }
          label={text}
          key={name}
        />
      );
    });
  }

  renderUsers(users) {
    return users.map((user) => (
      <MenuItem key={user.id} value={user.id}>
        {user.name}
      </MenuItem>
    ));
  }

  renderMedia(media) {
    if (media) {
      return (
        <img
          alt="media"
          src={media}
          style={{
            maxWidth: 300,
            display: 'flex',
            margin: 'auto',
          }}
        />
      );
    }
  }
  
  themeUpdated(theme) {
    console.log({updateTheme : theme});
    this.props.onUpdateRouteFunc('theme', theme);
  }

  render() {
    const { itemsDietaries, providersWhens, route, users, variables } = this.props;
    if (isEmpty(route)) return <div />;
    
    
    const theme = route.theme;
    console.log({ routeTheme : theme});
    const note = route.note || '';
    const notification = route.notification || '';
    const introduction = route.introduction || {};
    const introductionTitle = introduction.title || '';
    const introductionText = introduction.text || '';
    const media =
      introduction?.medias?.length > 0
        ? { type: 'image', url: introduction?.medias[0]?.url }
        : { type: 'image' };
    return (
      <div className={styles.root}>
        {this.renderTop(route)}
        <div className={styles.bottom}>
          {this.renderMoreToExploreCollection()}
          {this.renderDetails(route, users)}
          <div className={styles.dayList}>
            <p className={styles.title}>Suitable for</p>
            <div className={styles.days}>{this.renderWhens(providersWhens)}</div>
          </div>
          <div className={styles.variable}>
            {this.renderDietaries(itemsDietaries)}
            {this.renderVariables(variables)}
          </div>
          <span
            style={{
              color: 'black',
            }}
          >
            Note
          </span>
          <TextField
            value={note}
            className={styles.fullTextField}
            onChange={(e) => this.onChangeText('note', e)}
            multiline
            rows="15"
          />
          <span
            style={{
              color: 'black',
            }}
          >
            External Note
          </span>
          <TextField
            value={notification}
            className={styles.fullTextField}
            onChange={(e) => this.onChangeText('notification', e)}
            placeholder={`Add route-specific notes or leave blank for default content "We recommend you start around 11 am to ensure the experience flows well"`}
            multiline
            rows="15"
          />
          <ThemeDesigner theme={theme} onUpdateTheme={this.themeUpdated.bind(this)}/>

          <span
            style={{
              color: 'black',
              display: 'block',
              marginTop: '20px',
            }}
          >
            <SectionHeading>Introduction</SectionHeading>
          </span>
          <TextField
            value={introductionTitle}
            className={styles.fullTextField}
            placeholder="Title or leave blank for default content"
            onChange={(e) => this.onChangeIntroduction('title', e)}
          />
          <TextField
            value={introductionText}
            className={styles.fullTextField}
            placeholder="Text or leave blank for default content"
            onChange={(e) => this.onChangeIntroduction('text', e)}
            multiline
            rows="4"
          />
          <ACMedia
            name="routeMedia"
            media={media}
            accept="image/*"
            onUploadMediaFunc={(e) => this.onUploadIntroduction(e.target.files)}
            onClearMediaFunc={this.onClickClearMedia}
            isMediaTypeDisabled={true}
          />
        </div>
      </div>
    );
  }
}
